var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"zov-tabs-nav-action",class:_vm.classList,on:{"click":_vm.handleClick}},[_c('Icon',{staticClass:"zov-tabs-nav-action-icon",attrs:{"iconname":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }